export default {
  blog: {
    seo: {
      title: 'المدونة',
      description:
        'مقالات عملية عن التوصيل للمرحلة الأخيرة وإدارة الأساطيل وتجربة العملاء وكيف تستخدم الفرق Geofleet لعمليات توصيل أذكى.',
    },
    badge: 'المدونة',
    hero: {
      title: 'رؤى من أجل',
      titleHighlight: 'عمليات توصيل أذكى',
      description:
        'مقالات عملية عن التوصيل للمرحلة الأخيرة وإدارة الأساطيل وتجربة العملاء وكيف تستخدم الفرق Geofleet.',
    },
    filters: {
      categoryLabel: 'الفئة',
      allCategories: 'جميع الفئات',
      searchLabel: 'البحث في المقالات حسب العنوان',
      searchPlaceholder: 'البحث في المقالات...',
      all: 'الكل',
    },
    featured: {
      label: 'مقال مميز',
      readCta: 'قراءة المقال',
    },
    list: {
      latestTitle: 'أحدث المقالات',
      title: 'المقالات',
      showingInCategory: '{{count}} مقال في {{category}}',
      showingInCategory_other: '{{count}} مقالات في {{category}}',
      defaultSubtitle: 'وجهات نظر جديدة حول التوصيل والإرسال وعمليات الأسطول',
      article_one: '{{count}} مقال',
      article_other: '{{count}} مقالات',
    },
    empty: {
      title: 'لا توجد مقالات تطابق بحثك',
      hint: 'جرّب كلمات مفتاحية مختلفة أو اختر فئة أخرى.',
    },
    card: {
      readMore: 'اقرأ المزيد',
    },
    pagination: {
      previous: 'السابق',
      next: 'التالي',
      pageOf: 'صفحة {{current}} من {{total}}',
    },
    cta: {
      title: 'هل أنت مستعد لتحسين عمليات التوصيل؟',
      subtitle: 'ابدأ في دقائق. خطط من 100 دولار شهرياً لـ10 سائقين.',
    },
    post: {
      ogImageAlt: '{{title}} — مدونة Geofleet',
      backToBlog: 'العودة إلى المدونة',
      updatedOn: 'تم التحديث في {{date}}',
      publishedOn: 'نُشر في {{date}}',
      disclosure: 'إفصاح: تنشر Geofleet هذه المقارنة ونضع منتجنا في المرتبة الأولى. يُوصف كل منتج آخر استنادًا إلى صفحات المنتج والأسعار العامة لدى مزوّده، مع توصيف منصف لما يناسبه.',
      pitch: {
        eyebrow: 'جرّب خيارنا الأول',
        title: 'Geofleet: من 100 دولار شهريًا لـ10 سائقين',
        text: 'ابدأ مع Geofleet Lite بسعر 100 دولار شهريًا لـ10 سائقين و2,000 طلب، مع تخطيط المسارات والتتبع المباشر وروابط التتبع للعملاء وإثبات التسليم وإدارة الدفع عند الاستلام لموقع واحد. وتنتقل الفرق متعددة المواقع إلى Professional بدءًا من 19 دولارًا لكل سائق شهريًا، مع التتبع بعلامتك التجارية ووكلاء الذكاء الاصطناعي في الخطط الأعلى.',
        startFree: 'ابدأ الآن',
        bookDemo: 'احجز عرضًا توضيحيًا',
        caseStudy: 'اقرأ دراسة الحالة',
      },
      keyTakeaways: 'النقاط الرئيسية',
      tocAriaLabel: 'جدول المحتويات',
      tocTitle: 'المحتويات',
      relatedTitle: 'مقالات ذات صلة',
      cta: {
        title: 'استكشف مركز قيادة Geofleet',
        subtitle: 'اكتشف كيف يمكن لوكلاء الذكاء الاصطناعي تحسين عملياتك. ابدأ الآن أو احجز جولة مع فريقنا.',
        bookDemo: 'احجز عرض Geofleet',
        aiAgentsLink: 'وكلاء الذكاء الاصطناعي في Geofleet',
      },
    },
  },
};
